'use strict';
const { t } = require('services/i18nextWrapper');

let _elCustomDialog,
    /**
     * The Basic dialog popup.
     * @type {{setElement: Function, show: Function}}
     */
    CustomDialog = {
        /**
         * In order to use custom dialog, this are hosted in the main App module. And then,
         * available through this Object for the rest of the application.
         * @param notificationEl
         */
        setElement(notificationEl) {
            _elCustomDialog = notificationEl;
        },

        show() {
            _elCustomDialog.show(arguments);
        },

        showInfo(title, message, labelOk) {
            _elCustomDialog.showInfo(title, message, labelOk);
        },
        showWarningConfirmation(title, message, onConfirm, labelConfirm, labelCancel, onCancel, onClickAway) {
            if (_elCustomDialog) {
                _elCustomDialog.showWarningConfirmation(
                    title,
                    message,
                    onConfirm,
                    labelConfirm || t('confirm'),
                    labelCancel || t('cancel'),
                    onCancel,
                    onClickAway
                );
            }
        }
    };

module.exports = CustomDialog;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/Dialog/CustomDialogHolder.js
 **/